export default "__VITE_ASSET__CmsdId9___"